import React from 'react';
import { FormattedMessage } from 'react-intl';

const Page3_15 = () => {

    return (
        <div id="rsReview" className="fade-in">
            <div className="subsection">
                <div className="grid-row">
                    <div className="usa-alert-body gi-alert__info__body">
                        <p className="usa-alert-text">
                            <FormattedMessage
                                id='ssap.sign_and_review.time_to_review'
                                tagName='strong'
                            />
                            <br/>
                            <FormattedMessage id='ssap.sign_and_review.review_everything'/>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Page3_15;
